module.exports = "/_next/static/images/sellers_2_en-9b94a4280d8ddb112da561192fa5feb6.png";